import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_API_URL } from "../../utils/apiUtils";

export const queries = createApi({
	reducerPath: "queries",
	baseQuery: fetchBaseQuery({ baseUrl: BASE_API_URL }),
	endpoints: () => ({})
});
